(() => {
'use strict';
const $ = s => document.querySelector(s), $$ = s => [...document.querySelectorAll(s)];
const asset = n => window.PC_ATELIER_ASSETS[n];
const reduced = matchMedia('(prefers-reduced-motion: reduce)');
const pcPage = document.body.dataset.pcPage || 'figurine';
const offer = PC.catalog[pcPage].sizes;
const stages = [
 ['photos','Your photos','Share a front, side and back view, plus up to three close-ups. Tell us which details matter most.','You share the details.'],
 ['model','Your color preview','Our artisans refine the chibi design. A design preview arrives by email within 1–3 days after ordering. 3D modeling starts when you approve. With no reply, we remind you 3 days after sending your preview and start with the last preview 3 days later, with an email to let you know. Any reply stops the countdown.','You review their design.'],
 ['print','Printed in resin','Once 3D modeling is complete, we print an unpainted resin piece. When your piece is finished, we’ll add photos of each step to your private order page.','Their little shape takes form.'],
 ['sand','Smoothed by hand','Your piece is carefully sanded, ready for its colors and markings.',''],
 ['paint','Their colors, by hand','Their familiar markings come to life, one brushstroke at a time.',''],
 ['package','Packed with care','The finished piece is checked, photographed and carefully packed in our signature pink box.','']
];
let pictureToken = new WeakMap();
function changePicture(image, src, alt) {
 if(!image) return;
 const token = Symbol(); pictureToken.set(image,token);
 const next = new Image();
 next.onload = () => {
  if (pictureToken.get(image)!==token) return;
  if(image.hasAttribute('srcset')){image.removeAttribute('sizes');image.srcset=src;} image.src=src; image.alt=alt;
  if(window.gsap&&!reduced.matches) gsap.fromTo(image,{opacity:.55},{opacity:1,duration:.4,overwrite:true,clearProps:'opacity'});
 };
 next.onerror = () => { if(pictureToken.get(image)===token) image.alt=alt; };
 next.src=src;
}
function chooseSize(key,updateURL=false){
 const o=offer[key];if(!o)return;
 $$('[data-size]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.size===key)));
 const money=cents=>new Intl.NumberFormat('en-US',{style:'currency',currency:PC.currency,minimumFractionDigits:0,maximumFractionDigits:2}).format(cents/100);
 $$('[data-price]').forEach(e=>e.textContent=money(o.price));
 $$('[data-compare]').forEach(e=>{e.textContent=money(o.compare);e.hidden=!(o.compare>o.price);});
 $$('[data-save]').forEach(e=>{e.textContent='Save '+money(o.compare-o.price);e.hidden=!(o.compare>o.price);});
 $$('[data-size-label]').forEach(e=>e.textContent=o.label);
 $$('[data-start]').forEach(e=>{e.href=PC.customizeURL(pcPage,key);e.setAttribute('aria-disabled',String(!o.available));e.tabIndex=o.available?0:-1;});
 if(updateURL){const url=new URL(location.href);url.searchParams.set('variant',o.id);history.replaceState(null,'',url);}
}
$$('[data-size]').forEach(button=>button.addEventListener('click',()=>chooseSize(button.dataset.size,true)));
$$('[data-start]').forEach(link=>link.addEventListener('click',event=>{if(link.getAttribute('aria-disabled')==='true')event.preventDefault();}));
function sizeFromURL(){const query=new URLSearchParams(location.search);return Object.keys(offer).find(k=>String(offer[k].id)===query.get('variant')) || (query.get('size')==='large'?'large':'small');}
chooseSize(sizeFromURL());window.addEventListener('popstate',()=>chooseSize(sizeFromURL()));
$$('[data-gallery]').forEach(button=>button.addEventListener('click',()=>{
 const key=button.dataset.gallery, frame=$('.main-product'), src=button.dataset.src||asset(key);
 $$('[data-gallery]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
 frame.classList.toggle('photo-view',key!=='product-figurine');
 frame.dataset.lightbox=src; frame.dataset.caption=button.dataset.caption;
 changePicture($('.hero-object'),src,button.dataset.caption);
}));
$$('[data-scene]').forEach(button=>button.addEventListener('click',()=>{
 $$('[data-scene]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
 changePicture($('#life-image'),button.dataset.src||asset('scene-'+button.dataset.scene),button.dataset.alt||('Resin cat '+button.textContent.toLowerCase()));
}));
$$('[data-process]').forEach(button=>button.addEventListener('click',()=>{
 const n=Number(button.dataset.process),s=stages[n];
 $$('[data-process]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
 $('.chapter-number').textContent='0'+(n+1);
 $('#process-title').textContent=s[1]; $('#process-body').textContent=s[2]; $('#process-update').textContent=s[3];
 changePicture($('#process-image'),asset('process-'+s[0]),(pcPage==='keychain'?'West Highland terrier keychain making stage: ':'Border collie making stage: ')+s[1]);
 syncProcessVideoLabel();
}));
const lightbox=$('#lightbox'), film=$('#film');
const originalProcessVideo=film?.querySelector('video')?.getAttribute('src')||'';
const originalProcessPoster=film?.querySelector('video')?.getAttribute('poster')||film?.querySelector('video')?.dataset.poster||'';
const stepKeys=['photos','preview','print','sand','paint','pack'];
const stepLabels=['Watch the photo demo','Watch the preview demo','Watch the printing demo','Watch the finishing demo','Watch the painting demo','Watch the packing demo'];
function activeStep(){const b=$('[data-process][aria-pressed="true"]');return b?Number(b.dataset.process):4;}
function stepSrc(i){return film.dataset[stepKeys[i]+'Src']||'';}
function syncProcessVideoLabel(){
 const label=$('[data-video] span');
 if(label){const i=activeStep();label.textContent=stepSrc(i)?stepLabels[i]:'Watch real studio footage';}
}
syncProcessVideoLabel();

$$('[data-lightbox]').forEach(button=>button.addEventListener('click',()=>{
 lightbox.querySelector('img').src=button.dataset.lightbox;
 lightbox.querySelector('img').alt=button.dataset.caption;
 lightbox.querySelector('p').textContent=button.dataset.caption;
 lightbox.showModal();
}));
$('[data-video]')?.addEventListener('click',()=>{
 const i=activeStep(),ai=!!stepSrc(i),video=film.querySelector('video');
 const src=ai?stepSrc(i):originalProcessVideo;
 video.pause();
 if(video.getAttribute('src')!==src){
  video.setAttribute('src',src);
  if(ai)video.removeAttribute('poster');else video.setAttribute('poster',originalProcessPoster);
  video.load();
 }
 video.muted=true;video.currentTime=0;
 film.setAttribute('aria-label',ai?'AI-assisted demonstration':'Real PawChibi painting footage');
 const note=film.querySelector('p');note.textContent=ai?'':'Real painting footage from our studio. Different orders have different designs.';note.hidden=!note.textContent;
 film.showModal(); video.play().catch(()=>{});
});
$$('#lightbox, #film').forEach(dialog=>{
 dialog.querySelector('.dialog-close').addEventListener('click',()=>dialog.close());
 dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
 dialog.addEventListener('close',()=>dialog.querySelector('video')?.pause());
});
$('#hide-review')?.addEventListener('click',()=>{$('.review-toolbar').hidden=true;document.documentElement.style.setProperty('--review','0px');});
$$('a[href="#purchase"]').forEach(a=>a.addEventListener('click',e=>{const p=$('#purchase');if(!p||getComputedStyle(p).display!=='contents')return;const t=p.querySelector('.size-heading')||p.querySelector('[data-size]');if(!t)return;e.preventDefault();t.scrollIntoView({behavior:reduced.matches?'auto':'smooth',block:'center'});}));
const sticky=$('.sticky-buy'), mainCta=$('#purchase > .cta');
const mobile=matchMedia('(max-width:760px)');
if(sticky && mainCta && document.body.classList.contains('atelier')){
 sticky.hidden=false;
 let queued=false;
 function syncSticky(){
  queued=false;
  const overlay=Array.from(document.querySelectorAll('dialog[open],[role="dialog"],#shopify-pc__banner')).some(el=>el.getClientRects().length && getComputedStyle(el).visibility!=="hidden" && getComputedStyle(el).display!=="none");
  document.body.classList.toggle("pc-buy-overlay-open",overlay);
  const ctaBox=mainCta.getBoundingClientRect(), cover=sticky.offsetHeight||0;
  const active=mobile.matches && (ctaBox.bottom<=0 || ctaBox.top>=innerHeight-cover) && !overlay;
  sticky.classList.toggle('is-visible',active);
  sticky.inert=!active;
  if(sticky.getAttribute('aria-hidden')!==String(!active))sticky.setAttribute('aria-hidden',String(!active));
  document.body.classList.toggle('pc-mobile-buy-visible',active);
 }
 function scheduleSticky(){if(!queued){queued=true;requestAnimationFrame(syncSticky);}}
 window.addEventListener('scroll',scheduleSticky,{passive:true});
 window.addEventListener('resize',scheduleSticky,{passive:true});
 mobile.addEventListener('change',scheduleSticky);
 new MutationObserver(scheduleSticky).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['open','hidden','style','aria-hidden']});
 syncSticky();
}
// Motion is concentrated in one cover. No autoplay product gallery or price motion.
if(window.gsap){
 const mm=gsap.matchMedia();
 mm.add('(prefers-reduced-motion: no-preference)',()=>{
  if(document.body.classList.contains('atelier'))gsap.fromTo($('.hero-object'),{opacity:.7,y:10},{opacity:1,y:0,duration:.9,ease:'power2.out',clearProps:'transform,opacity'});
  const photo=$('.drift-photo');
  if(photo){
   const drift=gsap.to(photo,{scale:1.045,duration:12,ease:'sine.inOut',repeat:-1,yoyo:true,paused:true});
   let visible=false;
   const sync=()=>visible&&!document.hidden?drift.play():drift.pause();
   const io=new IntersectionObserver(es=>{visible=es[0].isIntersecting;sync();});io.observe(photo);
   document.addEventListener('visibilitychange',sync);
   return()=>{io.disconnect();document.removeEventListener('visibilitychange',sync);};
  }
 });
}
})();
